import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { ListResponse } from '../../../../../../models/list-response';
import { Customer } from '../../../../../../models/customer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { removeDuplicates } from '../../../../../../utils';


export interface BulkOperationCustomers {
  customerIds: number[];
  customerNames?: {[key: number]: string};
}


@Component({
  selector: 'app-obtain-bulk-operation-customers-modal',
  templateUrl: './obtain-bulk-operation-customers-modal.component.html',
  styleUrls: ['./obtain-bulk-operation-customers-modal.component.css']
})
export class ObtainBulkOperationCustomersModalComponent implements OnInit, OnDestroy {
  @Input() getPage: (pageNum: number) => Promise<ListResponse<Customer>>;
  @Input() totalNumPages: number;
  @Input() includeNames: boolean;
  @Input() resultCallback: (result: BulkOperationCustomers) => void;

  public serverError: number = null;

  // Used to halt any in-progress loading when the modal is closed.
  public modalClosed = false;

  // Used to display the loading bar while downloading.
  public pageNum = 1;

  private customerIds: number[] = [];
  private customerNames: {[key: number]: string} = {};

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.obtainCustomers().then();
  }

  ngOnDestroy() {
    this.modalClosed = true;
  }

  public getProgressPercentageStr() {
    return Math.ceil((this.pageNum / this.totalNumPages) * 100).toString();
  }

  private obtainCustomers(): Promise<void> {
    return this.getPage(this.pageNum)
      .then(result => {
        if (this.modalClosed) {
          return Promise.resolve();
        }

        for (const c of result.results) {
          this.customerIds.push(c.id);
          if (this.includeNames) {
            this.customerNames[c.id] = c.first_name + ' ' + c.last_name;
          }
        }

        if (!result.nextPage) {
          const bulkOperationCustomers: BulkOperationCustomers = {
            customerIds: removeDuplicates(this.customerIds)
          };
          if (this.includeNames) {
            bulkOperationCustomers.customerNames = this.customerNames;
          }
          this.resultCallback(bulkOperationCustomers);

          this.activeModal.close();

          return Promise.resolve();
        }

        this.pageNum++;

        return this.obtainCustomers();
      })
      .catch(reason => {
        this.serverError = reason.status;
      });
  }
}
